module.exports = __webpack_public_path__ + "img/dumbbell-duotone.d388980b.svg";